import React, { useEffect } from 'react';
import { useLocalStorage } from '../../services/hooks/useLocalStorage';
import { revokeToken, clearMFPUserSettings, restartApp } from '../../services/api';
import { STC_ID, STRATUS_ID } from '../../services/constants';
import Loading from '../Loading';

const Logout = () => {
    const [_user, setUser] = useLocalStorage('user', '');
    const [tenant, setTenant] = useLocalStorage('tenant', undefined);
    const [_accessToken, setAccessToken] = useLocalStorage('accessToken', undefined);
    const [_idToken, setIdToken] = useLocalStorage('idToken', undefined);
    const [refreshToken, setRefreshToken] = useLocalStorage('refreshToken', undefined);
    const [client, setClient] = useLocalStorage('client', undefined);
    const [_, setSqta] = useLocalStorage('dipa-sqta', '');
    const [stratus] = useLocalStorage("stratus", false);

    useEffect(() => {
        function clearData() {
            try {
                setTenant(undefined);
                setUser('');
                setAccessToken(undefined);
                setIdToken(undefined);
                setRefreshToken(undefined);
                setClient(undefined);
                setSqta('');
                clearKMCookies();
            } catch (e) {
                console.alert(e);
            }
        }
        async function clearKMCookies() {
            return new Promise((resolve, reject) => {
                if (window.km_cookie) {
                    try {
                        const urls = [
                            'bizhub.singles',
                            '0a0243a9.xyz',
                            'konicaminoltamarketplace.com',
                        ];
                        const regions = [
                            '',
                            'us'
                        ]
                        urls.forEach(url => {
                            regions.forEach(region => {
                                window.km_cookie.DeleteCookie(`${region}.${url}`, null);
                            });
                        });
                        const externalUrls = [
                            '.google.com',
                            '.youtube.com',
                            'accounts.google.com',
                            'accounts.youtube.com',
                            'microsoft.com',
                            'login.microsoft.com',
                            '.login.microsoft.com'
                        ]
                        externalUrls.forEach(url => {
                            window.km_cookie.DeleteCookie(`${url}`, null);
                        });
                        resolve(true);
                    } catch (e) {
                        console.log('Failed to clear cookies');
                        reject();
                    }
                } else {
                    resolve(true);
                }
            });
        }
        async function logoutUser(tenant, client) {
            try {
                if (!tenant)
                    throw new Error('tenant not defined')
                if (!client)
                    throw new Error('client not defined')

                const clientId = client?.ClientId;
                const redirectUrlBase = `https://${tenant.slug}.auth.${tenant.region}.amazoncognito.com/logout`

                // Revoke accessToken if possible
                if (tenant && refreshToken && client) {
                    await revokeToken(tenant.slug, refreshToken, client.ClientId, client.ClientSecret, tenant.region);
                }
                // Clear user data stored on MFP
                let appId = STC_ID;
                if (stratus) {
                    appId = STRATUS_ID;
                }
                await clearMFPUserSettings(appId);

                if (clientId) {
                    const params = new URLSearchParams({
                        client_id: clientId,
                        logout_uri: `${window.location.protocol}//${window.location.host}`,
                    })
                    const redirectUrl = `${redirectUrlBase}?${params.toString()}`;

                    window.location = redirectUrl
                } else {
                    redirect();
                }
            } catch (e) {
                console.log(e);
            } finally {
                clearData() // tenant=null, client=null
                redirect();
            }

        }

        function redirect() {
            let appId = STC_ID;
            if (stratus) {
                appId = STRATUS_ID;
            }
            restartApp(appId);
        }

        logoutUser(tenant, client);
    // eslint-disable-next-line
    }, [
        refreshToken,
        setAccessToken,
        setClient,
        setIdToken,
        setRefreshToken,
        setTenant,
        setUser,
        setSqta
    ]);

    return (
        <Loading/>
    )
}

export default Logout